import project_list from "../project_list";
import SectionTitle from "../components/SectionTitle";
import GlassCard from "../components/GlassCard";

export default function Projects() {
  return (
    <section id="Projects">
  <video autoPlay muted loop playsinline preload="auto" className="bg-video opacity-45">
    <source src="/vidbg2.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

      <SectionTitle
        componentStyle={"sec-title"}
        text="Projects"
      />
      <p className="text-white"></p>
      <div className="cards-container">
        {project_list.map((project, index) => (
          <GlassCard
            key={index}
            title={project.title}
            description={project.description}
            img={project.img}
            badgeText={project.category}
            techStack={project.tech}
            githubLink={project.links.github}
            demoLink={project.links.demo}
          />
        ))}
      </div>
    </section>
  );
}
